var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatDismiss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Regular icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M7.85355 7.14645C7.65829 6.95118 7.34171 6.95118 7.14645 7.14645C6.95118 7.34171 6.95118 7.65829 7.14645 7.85355L9.29289 10L7.14645 12.1464C6.95118 12.3417 6.95118 12.6583 7.14645 12.8536C7.34171 13.0488 7.65829 13.0488 7.85355 12.8536L10 10.7071L12.1464 12.8536C12.3417 13.0488 12.6583 13.0488 12.8536 12.8536C13.0488 12.6583 13.0488 12.3417 12.8536 12.1464L10.7071 10L12.8536 7.85355C13.0488 7.65829 13.0488 7.34171 12.8536 7.14645C12.6583 6.95118 12.3417 6.95118 12.1464 7.14645L10 9.29289L7.85355 7.14645ZM18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10L2.00738 10.3463L2.03275 10.7283C2.12433 11.7422 2.4066 12.7186 2.86169 13.6153L2.925 13.735L2.01493 17.3787L2.00114 17.4624L2.00131 17.5438C2.02622 17.8369 2.31127 18.0625 2.62109 17.9851L6.266 17.075L6.38669 17.1393C7.49591 17.7018 8.72679 18 10 18C14.4183 18 18 14.4183 18 10ZM3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10C17 13.866 13.866 17 10 17C8.7837 17 7.61362 16.6898 6.57701 16.1075L6.4903 16.0691L6.39873 16.0479C6.33662 16.0396 6.27294 16.0429 6.21104 16.0583L3.187 16.812L3.94274 13.7912L3.95692 13.6973C3.9621 13.603 3.94046 13.5084 3.89352 13.4249C3.31054 12.3878 3 11.217 3 10Z",
    fill: "#212121"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatDismiss);
export default __webpack_public_path__ + "static/media/chat-dismiss.0b638e59deb5e740ebb5e88b913af5e1.svg";
export { ForwardRef as ReactComponent };